import Vue from 'vue'
import CGrid from 'vue-cheetah-grid'
import vueCheetahGrid from 'vue-cheetah-grid'
import cheetahGrid from 'cheetah-grid'

cheetahGrid.themes.default = {
    borderColor: '#bebdb8',
    highlightBorderColor: '#1e88e5',
    frozenRowsBgColor: '#343a40',
    frozenRowsColor: 'white',
    selectionBgColor: '#b3e5fc',
    defaultBgColor(args) {
        const {row} = args;
        if (row%2 == 0) {
        return '#f2f2f2'
        } else {
        return 'white'
        }
    },
    color: 'black'
};

Vue.use(CGrid)
Vue.use(vueCheetahGrid)
Vue.use(cheetahGrid)